export const terms = {
    state: {
        terms: []
    },
    mutations: {
        SET_TERMS(state, terms) {
            state.terms = terms
        }
    },
    actions: {
        fetchTerms({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/orders/terms').then(response => {
                    commit('SET_TERMS', response.data.data)
                    resolve()
                })
            })
        }
    },
    getters: {
        terms: (state) => {
            return state.terms
        }
    }
}
